import React from 'react';
import { SectionLabel } from './SectionLabel';
import { systemMetrics, coverage } from '../data/offer';
export function SystemOverview() {
  return <section className="w-full border-y border-line bg-cream" aria-labelledby="system-heading" data-id="element-255" data-mp="18v0pou2pfh60">
      <div className="mx-auto max-w-5xl px-4 py-14 sm:px-5 sm:py-24" data-id="element-256" data-mp="1moi4y2ocy7q8">
        <SectionLabel data-id="element-257" data-mp="1ho487gs7ik7i">The simplest system for busy dog owners</SectionLabel>

        <h2 id="system-heading" className="mt-5 font-display text-[2rem] font-semibold leading-[1.05] tracking-[-0.02em] text-ink sm:mt-6 sm:text-[3.5rem] sm:leading-none" data-id="element-258" data-mp="tz1g1ezy58yr">
          The Perfect Dog Method™
        </h2>

        <p className="mt-5 max-w-3xl text-[15px] leading-relaxed text-ink/75 sm:mt-6 sm:text-lg" data-id="element-259" data-mp="13ttgqrotsbxr">
          Years of complex canine psychology distilled into a simple, 30-day
          roadmap any busy owner can follow. It’s not about “fixing” your dog;
          it’s about rewiring their habits through a science-based, 15-minute
          daily routine — so you stop guessing and start seeing results in as
          little as 48 hours.
        </p>

        <dl className="mt-10 grid grid-cols-2 gap-px bg-line sm:mt-14 lg:grid-cols-4" data-id="element-260" data-mp="284fjl285zits">
          {systemMetrics.map(metric => <div key={metric.label} className="bg-cream px-4 py-6 sm:px-7 sm:py-8" data-id="element-261" data-mp="2d2h4ztt2bu8f">
              <dt className="text-[10px] font-bold uppercase tracking-[0.14em] text-muted sm:text-[11px] sm:tracking-[0.16em]" data-id="element-262" data-mp="2i34x6it12h48">
                {metric.label}
              </dt>
              <dd className="mt-2 font-display text-3xl font-semibold leading-none text-terracotta sm:mt-3 sm:text-5xl" data-id="element-263" data-mp="1pg0u4jdhwcv3">
                {metric.value}
              </dd>
            </div>)}
        </dl>

        <div className="mt-12 sm:mt-16" data-id="element-264" data-mp="1z6c1yh0av679">
          <SectionLabel data-id="element-265" data-mp="11penmwj530n7">Total coverage</SectionLabel>
          <h3 className="mt-4 font-display text-xl font-semibold leading-snug text-ink sm:mt-5 sm:text-3xl" data-id="element-266" data-mp="11oln4darx7di">
            Every behavior that is driving you crazy
          </h3>

          <ul className="mt-6 grid gap-2.5 sm:mt-8 sm:grid-cols-2 sm:gap-3 lg:grid-cols-3" data-id="element-267" data-mp="yn0j5ebsrdhg">
            {coverage.map(item => <li key={item.number} className="flex items-center gap-3.5 border border-line bg-white px-4 py-3.5 sm:gap-4 sm:px-5 sm:py-4" data-id="element-268" data-mp="tofff4xc6bo9">
                <span className="font-display text-lg font-semibold text-terracotta/70" aria-hidden="true" data-id="element-269" data-mp="13f0mzhuzmqjb">
                  {item.number}
                </span>
                <span className="text-sm font-medium leading-snug text-ink" data-id="element-270" data-mp="aro2dd8e0ssn">
                  {item.label}
                </span>
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}